import Component from '../Component';
import * as eventNames from '../../customEventStrings';
import * as ids from '../../layerIdStrings';
import * as uiStrings from '../../uiStrings';
import Loader from './loader';

class Row extends Component {
	constructor(props) {
		super(props);

		this.isLayer = this.props.category === 'layer';
		this.isRastr = this.props.category === 'rastr';

		this.loader = new Loader();

		this.dialects = JSON.parse(document.getElementById("appContainer").dataset.dialects);
	}

	componentDidMount() {
		this.setupEventListeners();
		this.init();
	}

	init() {
		if (this.props.initial) {
			this.refs[`checkbox-${this.key}`].click();
		}
	}

	setupEventListeners() {
		const row = this.refs[`row-${this.key}`];
		const dialectsPickerButton = this.refs[`dialect-picker-button-${this.key}`];

		if (this.props.value) {
			this.refs[`name-${this.key}`].addEventListener('click', () => {
				this.refs[`checkbox-${this.key}`].click();
			});

			this.refs[`checkbox-${this.key}`].addEventListener('click', () => {

				const defaultCheckbox = this.refs[`input-${this.key}`];

				if (defaultCheckbox.type == "radio" && defaultCheckbox.checked) {
					return;
				}

				defaultCheckbox.checked = !defaultCheckbox.checked;

				if (defaultCheckbox.checked) {
					this.renderLoader();
				}

				if (this.isLayer) {
					if (defaultCheckbox.checked) {
						this.dispatchCustomEvent(eventNames.LAYER_ADDED, row, true, {
							props: this.props,
						});
					} else {
						this.dispatchCustomEvent(eventNames.LAYER_REMOVED, row, true, {
							props: this.props,
						});
					}

					if (this.props.icon) {
						this.refs[`icon-${this.key}`].classList.toggle('u-hidden');
					}

					//TOTO UROBI LIEVIK NEVIDITELNY, ked je zakomentovane 
					// if (this.props.type == 'markers' || this.props.id == ids.DIALECTS_FINE) {
					// 	dialectsPickerButton.classList.toggle('u-hidden');

					// 	if (!defaultCheckbox.checked) {
					// 		const dialectsPicker = row.nextElementSibling;
					// 		dialectsPicker.classList.add("u-hidden");
					// 	}
					// }

					if (this.props.id == ids.DIALECTS_COARSE || this.props.id == ids.DIALECTS_NONE) {
						const jemnejsiId = ids.DIALECTS_FINE;
						const jemnejsiRow = document.querySelector(`[ref="row-${jemnejsiId}"]`);
						const jemnejsiDialectsPickerButton = document.querySelector(`[ref="dialect-picker-button-${jemnejsiId}"]`);
						const jemnejsiDialectsPicker = jemnejsiRow.nextElementSibling;

						if (!jemnejsiDialectsPickerButton.classList.contains('u-hidden')) {
							jemnejsiDialectsPickerButton.classList.add('u-hidden');
						}

						if (!jemnejsiDialectsPicker.classList.contains("u-hidden")) {
							jemnejsiDialectsPicker.classList.add("u-hidden");
						}
					}
				}

				if (this.isRastr) {
					if (defaultCheckbox.checked) {
						this.dispatchCustomEvent(eventNames.RASTER_ADDED, row, true, {
							id: this.props.id,
						});
					} else {
						this.dispatchCustomEvent(eventNames.RASTER_REMOVED, row, true, {
							id: this.props.id,
						});
					}
				}
			});
		}

		if (dialectsPickerButton) {
			const dialectsPicker = row.nextElementSibling;
			dialectsPickerButton.addEventListener('click', () => {
				//const i = dialectsPickerButton.querySelector("i");
				//i.classList.toggle("fa-chevron-right");
				//i.classList.toggle("fa-chevron-down");

				dialectsPicker.classList.toggle("u-hidden");
			});

			dialectsPicker.addEventListener("click", e => {
				if (e.target.classList.contains("layerPanel__checkbox--custom")) {
					
					const checkbox = e.target.previousElementSibling;

					if (checkbox.disabled) {
						return;
					}

					checkbox.checked = !checkbox.checked;

					//this.renderLoader();

					if (this.props.type == 'markers') {
						// Check/uncheck all children
						e.target.closest("li").querySelectorAll('input[type="checkbox"]').forEach(child => {
							child.checked = checkbox.checked;
						});

						if (!checkbox.checked) {
							// Uncheck all parents
							let parent = e.target.closest("li").parentElement;

							while (!parent.classList.contains("js-dialect-picker")) {
								if (parent.tagName == "LI") {
									const elem = parent.children[0].querySelector('input[type="checkbox"]:checked');

									if (elem) {
										elem.checked = false;
									}
								}

								parent = parent.parentElement;
							}
						}
					}

					const dialectCount = dialectsPicker.querySelectorAll('input[type="checkbox"]:checked').length;
					dialectsPickerButton.classList.toggle("selected", dialectCount > 0);

					this.dispatchCustomEvent(eventNames.FILTER_ADDED, e.target, true, {
						id: this.props.id,
						dialectId: checkbox.value,
					});
				}
			});
		}

		const icon = this.refs[`icon-${this.key}`];

		if (icon) {
			icon.addEventListener("click", () => {
				this.dispatchCustomEvent(eventNames.OPEN_MODAL, document, false, { contentType: 'color-picker', contentKey: this.key});
			});
		}

		document.addEventListener(eventNames.CHANGE_CUSTOM_MARKER_COLOR, (e) => {
			if (`icon-${e.detail.id}` in this.refs) {
				this.refs[`icon-${e.detail.id}`].style.color = e.detail.color;
			}
		});

		document.addEventListener(eventNames.REMOVE_LAYER_PANEL_LOADER, (e) => {
			if (e.detail.id == this.props.id) {
				this.removeLoader();
			}
		});
	}

	renderLoader() {
		this.refs[`loader-container-${this.key}`].classList.remove('u-hidden');
		this.refs[`checkbox-${this.key}`].classList.add('u-hidden');
	}

	removeLoader() {
		// will be called multiple times in case of region loader - need to add
		// className only once
		if (!this.refs[`loader-container-${this.key}`].classList.contains('u-hidden')) {
			this.refs[`loader-container-${this.key}`].classList.add('u-hidden');
		}
		this.refs[`checkbox-${this.key}`].classList.remove('u-hidden');
	}

	getDialectsPickerHtml(parentId) {
		let result = `<ul style="list-style: none">`;
		for (let i in this.dialects) {
			const dialect = this.dialects[i];

			if (dialect.parent_id == parentId) {
				result += `
<li>
    <div style="display: flex; gap: .7em; margin-bottom: .3em">
        <div class="layerPanel__loader-container">
            <input type="checkbox" class="u-hidden" value="${dialect.id}"${(this.props.type != "overlay" || dialect.has_boundary == "1") ? '' : ' disabled'}>
            <span class="layerPanel__checkbox--custom"></span>
        </div>
        <span>${dialect.name}</span>
    </div>
`;

				if (dialect.children_count > 0) {
					result += this.getDialectsPickerHtml(dialect.id);
				}
				result += `</li>`
			}
		}
		return result + `</ul>`;
	}

	render() {
		let checkbox = "";

		if (this.props.value) {
			checkbox = `
            <div class="layerPanel__loader-container">
                <input
                    ref="input-${this.key}"
                    type="${this.props.inputType ? this.props.inputType : 'checkbox'}"
                    name="${this.props.inputName ? this.props.inputName : this.props.id}"
                    class="u-hidden js-query-picker ${this.props.chboxClassName ?? ''}"
                    value="${this.props.id}"
                >
                <span ref="checkbox-${this.key}" class="layerPanel__checkbox--custom"></span>
                <span ref="loader-container-${this.key}" class="u-hidden">
                    ${this.loader.render()}
                </span>
            </div>`;
		}

		const markerIcon = `<span ref="icon-${this.key}" title="${uiStrings.COLOR_SELECTION}" class="layerPanel__marker-icon js-marker-icon-color u-hidden" style="color: ${this.props.icon.color};"><i class="fas fa-map-marker-alt"></i></span>`;
		//const dialectsButton = `<button type="button" ref="dialect-picker-button-${this.key}" title="${uiStrings.DIALECT_SELECTION}" class="layerPanel__dialect-picker-button u-hidden"><i class="fas fa-filter"></i><span></span></button>`;
		const dialectsButton = `<button type="button" ref="dialect-picker-button-${this.key}" title="${uiStrings.DIALECT_SELECTION}" class="layerPanel__dialect-picker-button u-hidden"><i class="fas fa-filter"></i></button>`;
		const dialectsPicker = `<section class="js-dialect-picker u-hidden" style="margin-left: .6em">${this.getDialectsPickerHtml(null)}</section>`;


		return (`
        <div ref="row-${this.key}" id="${this.props.id}" class="${this.props.className ?? ''}">
            ${checkbox}
            <span ref="name-${this.key}" style="cursor: pointer;">${this.props.name}</span>
            ${(this.props.type == 'markers' || this.props.id == ids.DIALECTS_FINE) ? dialectsButton : ''}
            ${this.props.icon ? markerIcon : ''}
        </div>${(this.props.type == 'markers' || this.props.id == ids.DIALECTS_FINE) ? dialectsPicker : ''}`);

	}
}

export default Row;
